export default __webpack_public_path__ + "static/media/feature-resolve.e54a4fa9.png";